import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type IFT_015_2018Props = {};

const IFT_015_2018: React.FC<IFT_015_2018Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='IFT-015-2018'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                IFT-015-2018
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "ift_015_2018_title",
                    defaultMessage: "Technical specifications of the transmitting equipment intended for the specialized mobile fleet radiocommunication service"
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "ift_015_2018_scope",
                    defaultMessage: "This Technical Provision is applicable to all equipment intended for the specialized mobile radiocommunication service of fleets. The foregoing without prejudice to compliance with other applicable legal and administrative provisions."
                  })
                }
              </p>
            </div>
            
          </div>
          <div className="w-full mt-12 flex justify-center">
            <img className="max-w-md w-full" src="/img/radio.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IFT_015_2018;